const DeleteImgIcon = (props: any) => {
    return <img {...props} alt="delete.png" src={require('./delete.png')} />;
};

export default DeleteImgIcon;
